import apiUrl from './../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
//import VueElementLoading from 'vue-element-loading';
import {BasicSelect,  MultiSelect} from 'vue-search-select'
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import utility from './../../../utility/services/utility.service';
import Loader from './../../../shared/components/loader'
import Treeselect from '@riophae/vue-treeselect';
import {Validator} from 'vee-validate';
import iptracker from '../../../../views/components/commonfunction/iptracker';
import BookingService from '../../../cargobooking/services/cargobooking.service'

export default {
  name: 'changephysicalweight',
  components: {
    //VueElementLoading,
    Treeselect,
    Paginate,
    BasicSelect,
    utility,
    vueMultiSelect,
    iptracker,
    Loader
  },
  data: function() {
    return {
      physicalWt: '',
      shipmentId: '',
      physicalWeight:'',
      showPhysicalWt:false,
      isLoading:false,
      disableFileds:false,
      comments:'',
      userdetail:{},
      MaxTotalPhysicalWeight : null
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.userdetail =userdetail;
    this.getMaxVolumetricWeight()
  },
  methods: {
    isNumber: function(evt) {
      this.physicalWt = "";
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      }
      else if(evt.srcElement.value.length == 0 && evt.which == 48) {
        evt.preventDefault();
         return false;
      }
      else {
        return true;
      }
    },

    async updatePhysicalweight(){
      try{
        this.commenterr = ''
        if(this.physicalWeight == '' || this.physicalWeight == "0"){

          this.physicalWt = 'Physical weight must be greater than 0'
        }
        if (this.physicalWeight > this.MaxTotalPhysicalWeight) {
          this.$alert("Physical Weight must be less than "+ this.MaxTotalPhysicalWeight + " Kg", "", "error");
          return false;
        }
       else{
            this.isLoading=true;
            let payload = {
              'awb': this.shipmentId,
              'physicalWeight': this.physicalWeight.toString(),
              'comments':this.comments
            }
            let result = await utility.updatePhysicalWeight(payload);
            if(result.data.code == 200){
              this.$alertify.success(result.data.message);
              this.getTraceIP(payload);

            }else{
              this.$alertify.error(result.data.message);

            }
             this.isLoading=false;
             this.reset();
      }
    }
      catch(err){
        this.$alert(err,"","error");
      }
    },
    async onSubmitSearch() {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.updatePhysicalweight();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    async getInvoiceDetailsData(){
  try{
           this.physicalWeight = "";
            this.isLoading=true;
            let payload = {
              'awb': this.shipmentId,
              'type':"PhyWeight"
            }
            let result = await utility.getPhysicalWeight(payload);
            if(result.data.code == 200){
              this.showPhysicalWt = true;
              this.disableFileds = true;
              result.data.data.map(el =>{
              this.physicalWeight = el.totalphysicalweight
              });
            }
            else{
           this.$alertify.error(result.data.message);
            }
             this.isLoading=false;
      }
      catch(err){
        this.$alert(err,"","error");
      }
    },
    reset() {
      this.shipmentId = '',
      this.physicalWt = "";
      this.showPhysicalWt = false;
      this.disableFileds = false;
      this.$validator.reset();
      this.comments = ''
    },
    clearError(){
      this.physicalWt = "";
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.getInvoiceDetailsData(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    getTraceIP(data) {
      try {
        let payload = 
        {
          "projectname": this.userdetail.project,
          "type": "web",
          "userid": this.userdetail.userid,
          "username": this.userdetail.username,
          "routeurl":'/changephysicalweight',
          "meta" : {
            "event" : `Change Physical Weight`,
            "data" : data
          }
      }
      let result = iptracker.getTraceIP(payload);
      } catch (error) {
        console.log(error)
      }
      
    },
    async getMaxVolumetricWeight() {
      try {
        this.isLoading=true;
        let InputPayloadPhyWt = {
          key : "MAXPHYWT"
        }
        let physicalWeightResult = await BookingService.GetConfigDetailsFromKey(InputPayloadPhyWt);
        this.MaxTotalPhysicalWeight = physicalWeightResult.data.data.value[1]
        this.isLoading = false;
      } catch (err) {
        this.isLoading=false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/changephysicalweight/changephysicalweight.component.js